<app-agent-header [activeStep]="2" mobileTitle="Test taker details" [showAgentBadge]="true"></app-agent-header>
<main class="main-container">
  <div class="create-user-wrapper">
    <section class="back-link-section">
      <a class="d-inline-flex gap-8 align-items-center pointer" (click)="goBack()" title="Back">
        <span><img src="/assets/images/chevron-arrow-left-blue.svg" alt="chevron-arrow" class="chevronArrow object-fit-contain"></span>
        <span class="txt-baseBlue600 font-medium paragraph-extra-Medium paragraph-extra-Medium-768">Back</span>
      </a>
    </section>
    <section class="create-user-card-wrapper">
      <div class="create-user-card">
        <div class="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" class="d-none d-lg-block">
            <circle cx="20" cy="20" r="19" fill="#FDE8EB" stroke="none"/>
            <circle cx="20" cy="16" r="5" stroke="#A61242" stroke-width="1.5" fill="none"/>
            <path d="M10 32C10 27.5817 14.4772 24 20 24C25.5228 24 30 27.5817 30 32" stroke="#A61242" stroke-width="1.5" fill="none" stroke-linecap="round"/>
          </svg>
          <img src="/assets/images/Icon-duotone.svg" alt="test taker" class="d-block d-lg-none">
        </div>
        <h2 class="card-title">Test taker details</h2>
        <p class="card-description">Enter the test taker's details to continue with the booking.</p>
        <form class="create-user-form" [formGroup]="createUserForm">
          <div class="form-fields">
            <div class="field-group">
              <app-custom-bx-input id="firstName" type="text" placeholder="First name"
              [control]="createUserForm.get('firstName')" [firstErrorOnly]="true" [maxlength]="50"></app-custom-bx-input>
            </div>
            <div class="field-group">
              <app-custom-bx-input id="lastName" type="text" placeholder="Last name"
              [control]="createUserForm.get('lastName')" [firstErrorOnly]="true" [maxlength]="50"></app-custom-bx-input>
            </div>
            <div class="field-group">
              <app-custom-bx-input id="createEmail" type="text" placeholder="Email address"
                [control]="createUserForm.get('email')" [firstErrorOnly]="true"
              [customErrorMessage]="emailErrorMessages"></app-custom-bx-input>
            </div>
            <div class="field-group">
              <app-custom-bx-input id="createDob" type="date" placeholder="DD/MM/YYYY"
              [control]="createUserForm.get('dob')" [firstErrorOnly]="true" [disabled]="true"></app-custom-bx-input>
            </div>
          </div>
          @if (errorMessage) {
            <div class="error-field">
              <img width="16" height="16" src="/assets/images/danger.svg" alt="error">
              <span>{{ errorMessage }}</span>
            </div>
          }
        </form>
        <div class="consent-section" [ngClass]="{'consent-checked': consentChecked}" (click)="toggleConsent()">
          <div class="consent-checkbox">
            @if (consentChecked) {
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect width="20" height="20" rx="4" fill="#15803D"/>
                <path d="M5 10L8.5 13.5L15 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
            @if (!consentChecked) {
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" fill="white" stroke="#878787"/>
              </svg>
            }
          </div>
          <p class="consent-text">As an IDP agent, I acknowledge that I am not permitted to book this test until I have received the test taker's authorisation and consent to use their personal information.</p>
        </div>
        <button class="proceed-btn"
          [disabled]="createUserForm.invalid || !consentChecked"
          [ngClass]="createUserForm.invalid || !consentChecked ? 'btn-disabled' : ''"
        (click)="onConfirmAndProceed()">Confirm and proceed</button>
      </div>
    </section>
  </div>
</main>
<footer class="mobile-footer d-flex d-lg-none align-items-center justify-content-between">
  <a class="d-inline-flex gap-8 align-items-center pointer text-decoration-none" (click)="goBack()" title="Back">
    <span><img src="/assets/images/chevron-arrow-left-blue.svg" alt="chevron-arrow" class="chevronArrow object-fit-contain"></span>
    <span class="txt-baseBlue600 text-base lh-24 font-medium">Back</span>
  </a>
  <button class="mobile-proceed-btn"
    [disabled]="createUserForm.invalid || !consentChecked"
    [ngClass]="createUserForm.invalid || !consentChecked ? 'btn-disabled' : ''"
  (click)="onConfirmAndProceed()">Continue booking</button>
</footer>
